import React from 'react';
import { useSelector } from 'react-redux';
import ConversationErrorContainer from '../../ConversationErrorContainer';
import emptyStateBg from '../../../../../assets/empty-state.svg';
import {
  getCurrentFilter,
  getCustomFilterConversations,
} from '../../../selectors';
import GeckoLocation from 'services/gecko-location';
import { CONSTS } from 'constants/index.js';

const NoConversations = (props) => {
  const { openFilterModal } = props;
  const currentFilter = useSelector(getCurrentFilter);
  const customFilterConversations = useSelector(getCustomFilterConversations);
  if (
    currentFilter === CONSTS.FILTER_CUSTOM_FILTER &&
    !customFilterConversations.filters.length
  ) {
    return (
      <ConversationErrorContainer
        title="No Conversations to Display"
        icon="far fa-message-slash"
        description="No conversations have been filtered.  Try creating a new filter or return to your conversations."
        button={{
          name: 'Create New Filter',
          type: 'primary',
          icon: 'far fa-sliders-h',
          handler: () => openFilterModal(),
        }}
      />
    );
  }
  if (
    currentFilter === CONSTS.FILTER_CUSTOM_FILTER &&
    customFilterConversations.filters.length &&
    !customFilterConversations.fetching
  ) {
    return (
      <ConversationErrorContainer
        title="No Conversations Found"
        icon="far fa-exclamation-circle"
        description="There are no conversations that match your filter.  Try editing your current filter."
        button={{
          name: 'Edit Filter',
          type: 'primary',
          icon: 'far fa-edit',
          handler: () => openFilterModal(),
        }}
      />
    );
  }
  if (currentFilter === CONSTS.FILTER_UNDELIVERED) {
    return (
      <ConversationErrorContainer
        title="No conversations to display"
        icon="far fa-message-slash"
        description="There are no more conversations containing undelivered messages."
        button={{
          name: 'View all conversations',
          type: 'primary',
          icon: 'far fa-eye',
          handler: () =>
            GeckoLocation.goTo(GeckoLocation.location.hash, {
              filter: CONSTS.FILTER_MY_CONVERSATIONS,
            }),
        }}
      />
    );
  }
  return (
    <div className="ConversationErrorContainer">
      <div className="empty-state">
        <div className="empty-state d-flex flex-column align-items-center">
          <div
            className="empty-state-bg"
            style={{ backgroundImage: `url(${emptyStateBg})` }}
          ></div>
          <div className="empty-state-icon">
            <i className="far fa-message-slash"></i>
          </div>
          <div className="empty-state-content text-center">
            <h2>No Conversations to Display</h2>
            <p>
              It looks like you have no conversations assigned. You can start a
              new conversation or assign one to yourself.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoConversations;
